import Cookies from 'js-cookie';

import config from './config';


// TODO get rid on behalf of useSlingAPI


const Authorization = Cookies.get(config.AUTHORIZATION_COOKIE);
const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
};
if (Authorization) {
  Object.assign(DEFAULT_HEADERS, { Authorization });
}


export async function request(uri, { queryParams = {}, method = 'GET', headers = {}, body, raw = false } = {}) {
  const requestQueryParams = new URLSearchParams(queryParams);
  const nonce = new Date().getTime();
  requestQueryParams.set('nonce', nonce);

  const queryParamString = requestQueryParams.toString();
  const response = await fetch(`${config.API_URL}${uri}?${queryParamString}`,
    { method, headers: { ...DEFAULT_HEADERS, ...headers}, body, credentials: 'include' }
  );

  if (raw) {
    return response;
  }

  validate(response);
  return await response.json();
}

export function post(uri, payload, { raw = false } = {}) {
  // raw parameter will return a raw fetch object rather than awaited json
  return request(uri, {
    method: 'POST',
    headers: {
      'Content-type': 'application/json',
    },
    body: JSON.stringify(payload),
    raw,
  });
}

function validate(response) {
  if (response.ok) {
    return true;
  }

  if (response.status >= 400 && response.status < 500) {
    window.location.href = config.LOGIN_PAGE_URL;
  }
}
